/**
 * 承認方法・決定の日本語ラベル
 *
 * 文言はデスクトップアプリの ApprovalResultDisplay（getApprovalDecisionLabel）と統一する。
 * 未知の将来ソース値はそのまま表示する（フォールバック）。
 */

/** 決定種別の日本語ラベル（ユーザー決定の内訳） */
const DECISION_LABELS: Record<string, string> = {
  'allow-once': '今回のみ許可',
  'allow-task-scope': 'タスク中は許可',
  'allow-always': '常に許可',
  reject: '拒否',
  'reject-task-scope': 'タスク中は拒否',
};

/**
 * 承認結果（決定 + ソース）のラベルを取得
 *
 * デスクトップの getApprovalDecisionLabel と同一のマッピング。
 */
export function getApprovalResultLabel(decision: string, source: string): string {
  const approved = decision.startsWith('allow');
  switch (source) {
    case 'ai':
      return '自動承認（AI判定）';
    case 'workspace-bypass':
      return '自動承認（承認バイパス）';
    case 'whitelist':
      return '自動承認（ホワイトリスト）';
    case 'task-scope':
      return approved ? '自動承認（タスクスコープ）' : '自動拒否（タスクスコープ）';
    case 'timeout':
      return approved ? '自動承認（タイムアウト）' : '自動拒否（タイムアウト）';
    case 'user':
      return DECISION_LABELS[decision] ?? decision;
    default:
      // 未知の将来ソース値はそのまま表示
      return source;
  }
}

/**
 * ツール呼び出し上の承認方法ラベルを取得（ToolCallCard 用）
 *
 * 文言はデスクトップの ToolDisplay（getApprovalDecisionLabel）と統一する。
 * user ソースは決定ラベル（例: 「今回のみ許可」）、自動系はソース別ラベル
 * （例: 「自動承認（ホワイトリスト）」）を返す。決定省略時は allow-once を既定とする
 * （覗き見フォールバック autoApprovedBy 用）。
 */
export function getApprovalMethodLabel(source: string, decision?: string): string {
  return getApprovalResultLabel(decision ?? 'allow-once', source);
}
